<div class="flex-force flex-fill flex-col sidenav">
    @if (showSidenav()) {
    <app-plangebiete-bar></app-plangebiete-bar>
    <mat-nav-list class="flex-force flex-fill flex-col" [style.padding]="sidenavPadding()">
        <a mat-list-item color="secondary"
            class="flex-row color-primary-contrast backcolor-primary-contrast"
            [ngClass]="appStateService.sidenavExpanded() && rla.isActive ? 'selected-menu-item-expanded' : 'selected-menu-item-collapsed'"
            routerLink="/projekte"
            routerLinkActive="selected-menu-item-expanded"
            #rla="routerLinkActive"
            [activated]="rla.isActive"
            (click)="onNavigationClick(rla.isActive)">
            <span matListItemIcon 
                class="menu-icon icon ion-md-filing size-48"         
                [ngClass]="rla.isActive ? 'color-primary' : '$color-border'"></span>
            <span *ngIf="!appStateService.sidenavExpanded()" matListItemTitle style="display: none;"></span>
            <span *ngIf="appStateService.sidenavExpanded()" matListItemTitle class="flex-fill menu-title font-title-contrast">Projekte</span>
            <span *ngIf="appStateService.sidenavExpanded()" matListItemLine class="flex-fill menu-text font-header-contrast">Aktuelle Budgetanträge</span>
        </a>
        <div class="flex-force flex-fill menu-item-container"
            [style.height]="appStateService.sidenavExpanded() && rla.isActive ? 'calc(100vh - 402px)' : '0px'"
            [style.max-height]="appStateService.sidenavExpanded() && rla.isActive ? '610px' : '0px'"
            [ngClass]="appStateService.sidenavExpanded() && rla.isActive ? 'menu-item-container-expanded scrolling' : 'menu-item-container-collapsed no-scrolling'">
            <app-projekte-tree *ngIf="appStateService.sidenavExpanded()" class="flex-force flex-fill flex-col"></app-projekte-tree>
        </div>
        <a mat-list-item color="secondary"
            class="flex-row color-primary-contrast backcolor-primary-contrast"
            [ngClass]="appStateService.sidenavExpanded() && rla2.isActive ? 'selected-menu-item-expanded' : 'selected-menu-item-collapsed'"
            routerLink="/budgetantraege"
            routerLinkActive="selected-menu-item-expanded"
            #rla2="routerLinkActive"
            [activated]="rla2.isActive"
            (click)="onNavigationClick(rla2.isActive)">
            <span matListItemIcon 
                class="menu-icon material-symbols-outlined size-48"
                [ngClass]="rla2.isActive ? 'color-primary' : '$color-border'"
            >wallet</span>
            <span *ngIf="!appStateService.sidenavExpanded()" matListItemTitle style="display: none;"></span>
            <span *ngIf="appStateService.sidenavExpanded()" matListItemTitle class="flex-fill menu-title font-title-contrast">Archiv</span>
            <span *ngIf="appStateService.sidenavExpanded()" matListItemLine class="flex-fill menu-text font-header-contrast">Vergangene Budgetanträge</span>
        </a>
        <div class="flex-force flex-fill menu-item-container"
            [style.height]="appStateService.sidenavExpanded() && rla2.isActive ? 'calc(100vh - 503px)' : '0px'"
            [style.max-height]="appStateService.sidenavExpanded() && rla2.isActive ? '264px' : '0px'"
            [ngClass]="appStateService.sidenavExpanded() && rla2.isActive ? 'menu-item-container-expanded scrolling' : 'menu-item-container-collapsed no-scrolling'">
            <app-archiv-tree *ngIf="appStateService.sidenavExpanded()" class="flex-force flex-fill flex-col"></app-archiv-tree>
        </div>
    </mat-nav-list>
    <div class="flex-force flex-col button-container" [style.width]="buttonContainerWidth()">
        <button mat-button 
                class="button"
                matTooltip="Navigation" 
                (click)="onToggleNavigationClick()">
            <span color="secondary" class="material-symbols-outlined icon-24px icon-margin-top-6px">{{ appStateService.sidenavExpanded() ? 'left_panel_close' : 'right_panel_close'}}</span>
        </button>
    </div>
    }    
</div>
<div class="sidenav-round-corner"></div>




